import $ from 'jquery';

if( document.querySelector( '.js--section-accordion' ) ) {
  let accordionButton = document.querySelector( '.js--section-accordion' );
  let accordionSection = document.querySelector( '.js--section' );
  accordionButton.addEventListener( 'click', () => {
    // console.log( 'works' );
    accordionSection.classList.toggle('section--open');
    let size = document.querySelector('#disqus_thread').scrollHeight;
    if( size ) {
      size += 100;
    }
    console.log( size );
    if( accordionSection.classList.contains('section--open') ) {
      accordionSection.setAttribute( "style", `height: ${size}px` );
      accordionButton.textContent = 'Hide Comments';
    } else {
      accordionSection.setAttribute( "style", `height: 0px`);
      accordionButton.textContent = 'Leave A Comment';
    }
  } );
}
